// This script wraps all the CMS View / CMS Tech API calls.
// API calls are asynchronous. Clients must register to receive callbacks when the underlying data changes
// depends on the datastore
import {
    getState,
    dispatchBatch,
    dispatch,
    immState,
    ACTION_CLEAR_ASSETS_DATA,
    ACTION_CLEAR_ATTACHMENTS_DATA,
    ACTION_CLEAR_FINDINGS_DATA,
    ACTION_CLEAR_WORKORDERS_DATA,
    KEY_WORKORDERS_QUERY
} from "./cms_view_datastore";
// import removed: use immState from cms_view_datastore.js
import { cmsTechGetWorkOrderQuery } from "./cms_tech";

// Somebody somewhere must call refetchAllData() or the various fetch functions to
// bootstrap CMS View
// refetchAllData() is not called directly in this script.
export function refetchAllData() {
    var state = getState();
    dispatchBatch([
        [ACTION_CLEAR_ASSETS_DATA, null],
        [ACTION_CLEAR_ATTACHMENTS_DATA, null],
        [ACTION_CLEAR_FINDINGS_DATA, null],
        [ACTION_CLEAR_WORKORDERS_DATA, null]]);
    cmsTechGetWorkOrderQuery();
    // awh todo: examine clearing out the floorplans and buildings data.

    var id_floor = state.id_floor;
    if (id_floor) {
        fetchAssetsData(id_floor);
        fetchAttachmentsData(id_floor);
    }
    const woq = immState().get(KEY_WORKORDERS_QUERY);
    if (woq !== null) {
        fetchWorkordersData(woq.toJS());
    }
//    fetchFloorplansData()
//    fetchBuildingsData()
    //fetchSiteData();
    ts_temp__fetch_all(immState(), dispatch);
}

function refetchAttachmentsData() {
    state = getState()
    dispatch(ACTION_CLEAR_ATTACHMENTS_DATA, null);
    fetchAttachmentsData(state.id_floor);
}

// must be asynchronous
// contains stubbed success, error, and complete functions which the caller should override
// call with:
//  x = __buildGetApiCall(...)
//  do stuff to x...
//  x.success=function(data, textStatus, xhrxhr)
//  $.ajax(x)

function __buildGetApiCall(url, api_token, api_segment_id) {
    return {
        type: "GET",
        url: url,
        dataType: "json",
        headers: {
            Authorization: "Bearer " + api_token,
            Accept: "application/json, text/plain, */*",
            CmsSegmentId: api_segment_id,
            "Cache-Control": "no-cache",
            ModuleId: 1
        },
        complete: function (xhr, textStatus) {
            console.log("COMPLETE " + url + "  " + textStatus)
        },
        success: function (data, textStatus, xhrxhr) {
            console.error("success function for " + url + " was not overridden: " + textStatus)
        },
        error: function (xhr, textStatus, errorThrown) {
            console.error("ERROR " + url + "  " + textStatus + "  " + errorThrown)
        }
    }
}

// must be asynchronous
// contains stubbed success, error, and complete functions which the caller should override
// call with:
//  x = __buildPostApiCall(...)
//  x.success=function(data, textStatus, xhrxhr)
//  $.ajax(x)
function __buildPostApiCall(url, api_token, api_segment_id, data) {
    var r = __buildGetApiCall(url, api_token, api_segment_id);
    r.type = "POST";
    r.headers['Content-Type'] = 'application/json';
    r.data = JSON.stringify(data);
    return r;
}


/**
 *   Creates an attachment at the given id_location, coordinate and p1p2
 *   the success function is optional
 */

function postCreateAttachment(attachment_b64,
    file_extension,
    id_floor,
    coords,
    geo_reference,
    api_gateway,
    api_token,
    api_segment_id,
    success_function) {

    var url = api_gateway + "/api/drawinglocations/createattachment"

    var x = coords[0]
    var y = coords[1]
    var p1_x = geo_reference[0][0]
    var p1_y = geo_reference[0][1]
    var p2_x = geo_reference[1][0]
    var p2_y = geo_reference[1][1]
    var data_to_post = {
        data: attachment_b64,
        FileExtension: file_extension,
        idlocation: id_floor,
        idroom: "",
        xcoord: x,
        ycoord: y,
        p1xcoord: p1_x,
        p1ycoord: p1_y,
        p2xcoord: p2_x,
        p2ycoord: p2_y
    }

    call = __buildPostApiCall(url, api_token, api_segment_id, data_to_post)
    call.complete = function (xhr, textStatus) {
        // pass
    }
    call.success = function (retval, textStatus, xhrxhr) {
        dispatch(ACTION_API_CREATE_ATTACHMENT, retval);
        if ($.isFunction(success_function)) {
            success_function(retval)
        }
    }
    call.error = function (xhr, textStatus, errorThrown) {
        dispatch(ACTION_API_CREATE_ATTACHMENT, "error");
        console.error("ERROR " + xhr.status + " // " + url + " // " + textStatus + "  " + errorThrown)
    }
    dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, VALUE_CREATING_ATTACHMENT_API_BUSY)
    $.ajax(call)
}





function post_updateattachment(attachment_url,
    id_attachment,
    id_floor,
    coords,
    geo_reference,
    api_gateway,
    api_token,
    api_segment_id,
    success_function) {

    var url = api_gateway + "/api/drawinglocations/updateattachment"

    var x = coords[0]
    var y = coords[1]
    var p1_x = geo_reference[0][0]
    var p1_y = geo_reference[0][1]
    var p2_x = geo_reference[1][0]
    var p2_y = geo_reference[1][1]
    var data_to_post = {
        //data : attachment_b64,
        //FileExtension : file_extension,
        url: attachment_url,
        data: "AAAAAAAA",        // data value is both required and ignored by the API.          AWH TODO: remove them from the API call
        FileExtension: "png",  // FileExtension values is both required and ignored by the API. AWH TODO: remove them from the API call
        id: id_attachment,
        idlocation: id_floor,
        idroom: "",
        xcoord: x,
        ycoord: y,
        p1xcoord: p1_x,
        p1ycoord: p1_y,
        p2xcoord: p2_x,
        p2ycoord: p2_y
    }

    call = __buildPostApiCall(url, api_token, api_segment_id, data_to_post)
    call.complete = function (xhr, textStatus) {
        // pass
    }
    call.success = function (retval, textStatus, xhrxhr) {
        dispatch(ACTION_API_UPDATEATTACHMENT_SUCCESS, retval);
        if ($.isFunction(success_function)) {
            success_function(retval)
        }
    }
    call.error = function (xhr, textStatus, errorThrown) {
        dispatch(ACTION_API_UPDATEATTACHMENT_FAIL, "error");
        console.error("ERROR " + xhr.status + " // " + url + " // " + textStatus + "  " + errorThrown)
    }
    dispatch(ACTION_API_UPDATEATTACHMENT_START, null)
    $.ajax(call)
}


/**
 *   Creates an attachment at the given id_location, coordinate and p1p2
 *   the success function is optional
 */

function postCreateAttachmentV2(attachment_b64,
    file_extension,
    id_floor,
    coords,
    geo_reference,
    api_gateway,
    api_token,
    api_segment_id,
    success_function) {

    var url = api_gateway + "/api/drawinglocations/createattachment"

    var x = coords[0]
    var y = coords[1]
    var p1_x = geo_reference[0][0]
    var p1_y = geo_reference[0][1]
    var p2_x = geo_reference[1][0]
    var p2_y = geo_reference[1][1]
    var data_to_post = {
        data: attachment_b64,
        FileExtension: file_extension,
        idlocation: id_floor,
        idroom: "",
        xcoord: x,
        ycoord: y,
        p1xcoord: p1_x,
        p1ycoord: p1_y,
        p2xcoord: p2_x,
        p2ycoord: p2_y
    }

    call = __buildPostApiCall(url, api_token, api_segment_id, data_to_post)
    call.complete = function (xhr, textStatus) {
        // pass
    }
    call.success = function (retval, textStatus, xhrxhr) {
        dispatch(ACTION_API_CREATEATTACHMENT_SUCCESS, null);
        if ($.isFunction(success_function)) {
            success_function(retval)
        }
    }
    call.error = function (xhr, textStatus, errorThrown) {
        dispatch(ACTION_API_CREATEATTACHMENT_FAIL, null);
        console.error("ERROR " + xhr.status + " // " + url + " // " + textStatus + "  " + errorThrown)
    }
    dispatch(ACTION_API_CREATEATTACHMENT_START, null);
    dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, ts_temp__state_values.STATE_CREATING_ATTACHMENT_API_BUSY);
    $.ajax(call)
}

/** 
 *  fetches data about the attachments for a given floor from the API gateway
 */
export function fetchAttachmentsData(id_floor) {
    return ts_temp__api_getattachmentsbylocation(immState(), dispatch, id_floor)
}

//
// forces an update of the floorplans and updates the datastore.
// This should only be called to force an update of the floorplans.

function fetchWorkordersData(workorder_query) {
    ts_temp__api_get_workorders(immState(), dispatch, workorder_query);
}

export function fetchAssetsData(id_floor)  // call every time a floor is loaded
{
    ts_temp__api_DrawingLocations_GetAssetsByFloor(immState(), dispatch, id_floor)
}
function fetchFindingsData(id_floor)  // call every time a floor is loaded
{
    ts_temp__api_DrawingLocations_GetFindingsByFloor(immState(), dispatch, id_floor)
}






// WEBPACK FOOTER //
// ./js/cms_apis.js